import { footerData } from "@/mocks/homeData";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-8 md:py-16">
        <div className="hidden md:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/1c3ecf48-285d-4989-a01a-b0386ca0101e.png"
                alt="ノーブルラボ"
                className="h-8 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed mb-2">
              {footerData.department}
            </p>
            <div className="mt-4 pt-4 border-t border-background-200/70 space-y-1">
              <p className="text-xs text-foreground-600 leading-relaxed">
                {footerData.address.postal}
              </p>
              <p className="text-xs text-foreground-600 leading-relaxed whitespace-pre-line">
                {footerData.address.full.replace(' ', '\n')}
              </p>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {footerData.address.company}
              </p>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {footerData.address.tel}
              </p>
            </div>
          </div>

          {/* Services */}
          <div className="hidden md:block">
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              サービス
            </h4>
            <ul className="space-y-2.5">
              {footerData.links.service.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div className="hidden md:block">
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              情報
            </h4>
            <ul className="space-y-2.5">
              {footerData.links.info.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="hidden md:block">
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              会社情報
            </h4>
            <ul className="space-y-2.5">
              {footerData.links.company.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <img
                src="https://storage.readdy-site.link/project_files/7ff52860-4523-46dc-8cf3-4045b0a37116/f935bbd7-5746-4142-886a-0ce7a7aa1c07_compressed_21004773_jp.webp"
                alt="プライバシーマーク"
                className="h-14 w-auto object-contain"
              />
            </div>
          </div>
        </div>

        <div className="md:mt-12 pt-0 md:pt-6 md:border-t border-background-200/70 text-center">
          <p className="text-xs text-foreground-600">{footerData.copyright}</p>
        </div>
      </div>
    </footer>
  );
}